


























import { Component, Vue } from 'vue-property-decorator';

interface ILoginData {
  username: string;
  password: string;
}

@Component({
  components: {},
})
export default class Login extends Vue {
  private showPassword: boolean = false;
  private input: ILoginData = { username: '', password: '' };
  private loginResult: string = '';
  private ready: boolean = false;

  public async mounted() {
      const self = this;
      this.ready = false;

      const token = this.$route.query.token;

      if ( token !== undefined && token !== null ) {

        const response = await self.$store.dispatch('verifyToken', token);

        const isauth = self.$store.getters.isAuthenticated;
        if (isauth) {
            self.$router.replace({ name: 'dashboard' });
        } else {
            console.log('token passed is incorrect');
            self.loginResult = 'Token Authenication failure';
            self.ready = true;
        }
      } else {
        console.log('token not present');
        self.ready = true;
      }
  }

  public enterClicked() {
    this.login();
  }

  public async login() {
    const self = this;

    if (this.input.username !== '' && this.input.password !== '') {
      const response = await this.$store.dispatch('obtainToken', {
        username: self.input.username.toString(),
        password: self.input.password.toString(),
      });

      const isauth = self.$store.getters.isAuthenticated;
      if (isauth) {
        // self.$emit('authenticated', true);
        self.$router.replace({ name: 'dashboard' });
      } else {
        console.log('The username and / or password is incorrect');
        self.loginResult = 'Authenication failure';
      }
    } else {
      console.log('A username and password must be present');
      self.loginResult = 'Authenication failure';
    }
  }
}
